/**
 * The advisor's design tokens.
 *
 * The rest of the app is antd + .less; this panel is a Tailwind island, so the class strings its
 * blocks and controls share live here rather than in a stylesheet — one place to change a
 * surface, a focus ring or the horizontal rhythm for the whole module.
 */

/** Every in-transcript surface: card, table shell, chart frame. Border only — no elevation. */
export const SURFACE = "rounded-lg border border-gray-200 bg-white";

/**
 * Tailwind v2 only generates `focus` variants for the ring utilities out of the box —
 * `focus-visible` would need wiring up in tailwind.config.js — so this shows on click as well
 * as on tab.
 */
export const FOCUS_RING =
  "focus:outline-none focus:ring-2 focus:ring-revampBlue focus:ring-offset-1";
